import { login as loginApi, logout as logoutApi } from '@/api/auth'
import { getUserMenus, getUserPerms } from '@/api/auth'
import { getToken, setToken, removeToken, getUserInfo, setUserInfo, removeUserInfo } from '@/utils/auth'
import { resetDynamicRoutes } from '@/permission'

const state = {
  token: getToken() || '',
  userInfo: getUserInfo() || null,
  // 动态路由菜单（后端返回的树形结构）
  menuList: [],
  // 权限标识列表（按钮权限，如 ['member:export', 'order:export']）
  permissions: []
}

const mutations = {
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo
  },
  SET_MENUS(state, menus) {
    state.menuList = menus
  },
  SET_PERMISSIONS(state, perms) {
    state.permissions = perms
  }
}

const actions = {
  // 登录（成功后立即加载菜单和权限，确保跳转前数据就绪）
  login({ commit, dispatch }, loginForm) {
    return new Promise((resolve, reject) => {
      loginApi(loginForm).then(res => {
        const data = res.data
        setToken(data.token)
        commit('SET_TOKEN', data.token)
        const userInfo = { username: data.username, realName: data.realName, roles: data.roles, roleNames: data.roleNames }
        setUserInfo(userInfo)
        commit('SET_USER_INFO', userInfo)
        // 链式加载菜单和权限，确保登录完成后 menuList 已填充
        return dispatch('getInfo')
      .then(() => {
        resolve(res)
      })
      }).catch(error => {
        reject(error)
      })
    })
  },

  // 获取用户信息、菜单和权限（登录后调用）
  getInfo({ commit }) {
    return new Promise((resolve, reject) => {
      // 并行请求菜单和权限
      Promise.all([getUserMenus(), getUserPerms()])
        .then(([menuRes, permRes]) => {
          const menus = menuRes.data || []
          const perms = permRes.data || []
          commit('SET_MENUS', menus)
          commit('SET_PERMISSIONS', perms)
          resolve({ menus, perms })
        })
        .catch(error => {
          reject(error)
        })
    })
  },

  // 退出登录
  logout({ commit }) {
    return new Promise((resolve, reject) => {
      logoutApi().then(() => {
        commit('SET_TOKEN', '')
        commit('SET_USER_INFO', null)
        commit('SET_MENUS', [])
        commit('SET_PERMISSIONS', [])
        removeToken()
        removeUserInfo()
        resetDynamicRoutes()
        resolve()
      }).catch(() => {
        commit('SET_TOKEN', '')
        commit('SET_USER_INFO', null)
        commit('SET_MENUS', [])
        commit('SET_PERMISSIONS', [])
        removeToken()
        removeUserInfo()
        resetDynamicRoutes()
        resolve()
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
